import gql from 'graphql-tag';

export const removeSupplyObjectMutation = gql`
  mutation RemoveSupplyObject($id: ID!) {
    removeSupplyObject(id: $id)
  }
`;